import React from "react";

import "../styles.scss";
import "../scripts";

import {
  secondaryBlock,
  SecondaryBlockSize,
  KameleonElement,
  SecondaryBlockConfig,
  getDefaultProps,
} from "@kameleon-core/lib";
import { Box } from "theme-ui";
import { Variants } from "@kameleon-util/global-theme";
import blockinfo from "./blockinfo.json";
import defaults from "./defaults.json";
import { PointsType, layoutOptions } from "./types/prop-types";

/** Points Secondary */
const blockConfig: SecondaryBlockConfig = {
  blockSize: SecondaryBlockSize.Medium,
};

const PointsComponent = ({
  points,
  layoutProps,
  _internalProps,
}: PointsType) => (
  <Box className={_internalProps?._className ?? "secondary-points-two-col-v1"}>
    <Box className="pricing5_feature-list">
      {points.map((point, index) => (
        <Box key={index} className="pricing5_feature">
          <Box className="pricing5_icon-wrapper">
            <Variants.IconTiny
              icon={point.icon}
              hasBg={layoutProps.showIconBackground}
            />
          </Box>
          <Variants.ParagraphDefault>{point.text}</Variants.ParagraphDefault>
        </Box>
      ))}
    </Box>
  </Box>
);

export const Points = secondaryBlock<PointsType>(blockConfig, PointsComponent);
Points.defaultProps = getDefaultProps<PointsType>(defaults);

export const Element: KameleonElement = {
  component: Points,
  blockInfo: blockinfo,
  defaultProps: {
    layoutProps: defaults.layoutProps,
    contentProps: defaults.contentProps,
  },
  layoutOptions,
};
